module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "ctn-operation-form take-place"
  }, [_c('div', {
    staticClass: "white-box row title"
  }, [_c('router-link', {
    staticClass: "ctn-icon",
    attrs: {
      "to": {
        name: 'TransactionsTable'
      }
    }
  }, [_c('span', {
    staticClass: "icon-arrow-back"
  })]), _vm._v(" "), (_vm.missionExist) ? _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\t" + _vm._s(_vm.name) + "\n\t\t")]) : _c('div', {
    staticClass: "label"
  }, [_vm._v("\n\t\t\tNouvelle opération\n\t\t")])], 1), _vm._v(" "), _c('div', {
    staticClass: "white-box"
  }, [_c('edit-main'), _vm._v(" "), (_vm.missionExist) ? _c('div', {
    staticClass: "take-place"
  }, [_c('div', {
    staticClass: "separator"
  }), _vm._v(" "), _c('edit-docs', {
    attrs: {
      "operation": _vm.operation
    },
    on: {
      "needToUpdate": _vm.checkForOperation
    }
  }), _vm._v(" "), _c('edit-contracts-and-supports')], 1) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-864d0ac8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MyTransactions/Edit.vue
// module id = 1157
// module chunks = 0